import React, { useContext } from 'react';
import S from "./Text";
import CardHeader from "../CardHeader";
import FundContext from "@/components/FundSingle/FundProvider";

export interface TableProps {
    title?: string;
    subTitle?: string;
    text?: string;
}

const Text: React.FC<TableProps> = ({ title, subTitle, text}) => {

    return (
        <S.TextWrapper>
            {title && <CardHeader title={title} subTitle={subTitle} />}
            <S.TextContent>
                {text}
            </S.TextContent>
        </S.TextWrapper>
    );
};

export default Text;
